Ext.define('SA.view.barchart.BarChart', {
    extend: 'Ext.Component',
    alias: 'widget.bar-chart',

    cls: 'sa-bar-chart',

    getSvg() {
        return this.el.down('svg', true).cloneNode(true);
    },

    renderChart({space, attribute, data, formatCfg}) {
        var svg = SA.BarChartRenderer.render({space, attribute, data, formatCfg});

        this.el.dom.querySelector('svg')?.remove();
        this.el.dom.append(svg);
    }
});